package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class ContentConnectionEntityType(private val literal: String) : IEnumType {
	SignSymptom("SignSymptom"),
	Medicine("Medicine"),
	Prescription("Prescription"),
	Disease("Disease"),
	MedicalRecord("MedicalRecord"),
	DifferentiationRule("DifferentiationRule");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "content_connection_entity_type"}
	override fun getLiteral(): String {return literal}
}
